export default {
    getRestaurant: state => state.restaurant,
    getError: state => state.error,
    getActiveMenu: state => state.selectedMenuIndex,
}